import React from 'react';
import LegalLayout from './LegalLayout';
import { WHATSAPP_CONTACT_URL } from '../landing/content';

// ATENÇÃO: texto-base sujeito a revisão jurídica. Trechos entre colchetes são
// placeholders a serem preenchidos com os dados reais da empresa.
const SECTIONS = [
  {
    id: 'introducao',
    title: 'Introdução',
    blocks: [
      'Esta Política de Privacidade explica como o FlowVendas, sistema de gestão (ERP) em nuvem oferecido por [RAZÃO SOCIAL], inscrita no CNPJ sob o nº [CNPJ], com sede em [ENDEREÇO], trata dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD).',
    ],
  },
  {
    id: 'papeis',
    title: 'Nosso papel no tratamento de dados',
    blocks: [
      { list: [
        'Como controlador, tratamos os dados de quem se cadastra e usa o FlowVendas (o usuário e o estabelecimento contratante).',
        'Como operador, tratamos, em nome do estabelecimento contratante, os dados pessoais de seus clientes finais inseridos no sistema (por exemplo, clientes e veículos). Nesse caso, o estabelecimento é o controlador desses dados.',
      ] },
    ],
  },
  {
    id: 'dados-coletados',
    title: 'Dados que coletamos',
    blocks: [
      'No cadastro, coletamos: nome do estabelecimento, segmento, nome, sobrenome, e-mail, celular e senha.',
      'Durante o uso do sistema, são tratados os dados que o estabelecimento e seus usuários inserem, como cadastros de clientes e veículos, produtos, estoque, vendas, ordens de serviço, orçamentos, checklists, movimentações financeiras e de caixa, e informações dos usuários e perfis de acesso.',
      'Também são registradas informações de utilização e segurança, como registros de auditoria das ações realizadas no sistema.',
      'Se você utilizar o assistente de IA, as perguntas enviadas e as informações do sistema necessárias para respondê-las são processadas para gerar a resposta. Se utilizar a integração com WhatsApp, os dados necessários ao envio das mensagens (como número de telefone do destinatário e o conteúdo do documento ou aviso) são tratados para essa finalidade.',
    ],
  },
  {
    id: 'finalidades',
    title: 'Para que usamos os dados',
    blocks: [
      { list: [
        'criar e administrar sua conta e autenticar seu acesso;',
        'prestar o serviço contratado e disponibilizar as funcionalidades do sistema;',
        'oferecer e gerenciar o período de teste e os planos;',
        'entrar em contato para suporte, avisos sobre o serviço e comunicações relacionadas à conta;',
        'garantir a segurança, prevenir fraudes e manter registros de auditoria;',
        'cumprir obrigações legais e regulatórias e exercer direitos em processos judiciais ou administrativos;',
        'melhorar o desempenho e a qualidade do sistema.',
      ] },
    ],
  },
  {
    id: 'bases-legais',
    title: 'Bases legais',
    blocks: [
      'O tratamento ocorre com fundamento nas bases legais previstas na LGPD, conforme o caso, em especial: execução de contrato ou de procedimentos preliminares a ele relacionados, cumprimento de obrigação legal ou regulatória, exercício regular de direitos, legítimo interesse e consentimento.',
    ],
  },
  {
    id: 'compartilhamento',
    title: 'Compartilhamento de dados',
    blocks: [
      'Não vendemos dados pessoais. Podemos compartilhá-los quando necessário com prestadores de serviços que nos apoiam na operação do sistema (como infraestrutura em nuvem, envio de e-mails, processamento de inteligência artificial e mensageria/WhatsApp), com autoridades quando houver obrigação legal ou ordem judicial, e com outros terceiros mediante sua autorização. Lista de prestadores: [LISTA DE OPERADORES/SUBPROCESSADORES].',
      'Cada estabelecimento possui seu ambiente próprio, e os dados de um estabelecimento não são disponibilizados a outros estabelecimentos.',
    ],
  },
  {
    id: 'transferencia',
    title: 'Transferência internacional',
    blocks: [
      'Alguns prestadores de serviços podem armazenar ou processar dados fora do Brasil. Nesses casos, adotamos as salvaguardas previstas na LGPD. Países e detalhes: [PAÍSES/DETALHES DE TRANSFERÊNCIA INTERNACIONAL].',
    ],
  },
  {
    id: 'retencao',
    title: 'Armazenamento e retenção',
    blocks: [
      'Mantemos os dados pelo tempo necessário para cumprir as finalidades descritas nesta Política, durante a vigência do contrato e pelos prazos exigidos ou permitidos por lei. Prazos de retenção após o encerramento da conta: [PRAZO DE RETENÇÃO]. Após esse período, os dados são excluídos ou anonimizados, salvo obrigação legal de guarda.',
    ],
  },
  {
    id: 'seguranca',
    title: 'Segurança',
    blocks: [
      'Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, perda, alteração ou divulgação indevida, incluindo autenticação por credenciais, controle de acesso por perfis de usuário e separação dos dados por estabelecimento. Nenhum sistema é totalmente imune a riscos; em caso de incidente relevante, comunicaremos os envolvidos e a ANPD nos termos da lei.',
      'Você também é responsável por manter suas credenciais em sigilo e por conceder acesso apenas a pessoas autorizadas.',
    ],
  },
  {
    id: 'direitos',
    title: 'Seus direitos como titular',
    blocks: [
      'Nos termos da LGPD, você pode solicitar: confirmação da existência de tratamento; acesso aos dados; correção de dados incompletos, inexatos ou desatualizados; anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade; portabilidade; informação sobre compartilhamentos; informação sobre a possibilidade de não consentir e suas consequências; revogação do consentimento; e oposição a tratamento realizado com base em outra hipótese legal.',
      'Se você é cliente final de um estabelecimento que utiliza o FlowVendas, sua solicitação deve ser dirigida preferencialmente a esse estabelecimento, que é o controlador dos seus dados; poderemos apoiá-lo no atendimento.',
    ],
  },
  {
    id: 'cookies',
    title: 'Armazenamento local e cookies',
    blocks: [
      'O sistema utiliza o armazenamento do seu navegador para manter sua sessão autenticada e suas preferências, como o tema claro ou escuro. Esses itens são necessários ao funcionamento do serviço.',
    ],
  },
  {
    id: 'alteracoes',
    title: 'Alterações desta Política',
    blocks: [
      'Esta Política pode ser atualizada periodicamente. A data da última atualização é informada no início desta página. Em caso de mudanças relevantes, buscaremos informá-lo por meios adequados.',
    ],
  },
  {
    id: 'contato',
    title: 'Contato e encarregado (DPO)',
    blocks: [
      'Para exercer seus direitos ou tirar dúvidas sobre esta Política, entre em contato com o encarregado pelo tratamento de dados pessoais: [NOME DO ENCARREGADO (DPO)], e-mail [E-MAIL DO ENCARREGADO (DPO)]. Contato geral: [E-MAIL DE CONTATO].',
      { link: { label: 'Falar pelo WhatsApp', href: WHATSAPP_CONTACT_URL } },
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Política de Privacidade"
      intro="Entenda quais dados o FlowVendas coleta, para que os utiliza e quais são os seus direitos."
      sections={SECTIONS}
    />
  );
}
